import arrow from '../assets/arrowBlue.svg';

export const LinkBlue = (props: any) => {
  const showArrow = props.arrow

  return  <div className="go-with-google">
  <a href={props.linkMaps} >{props.linkBlue}</a>
  <img src={`${showArrow ? arrow : ''}`} alt="" />
</div> 
}